export enum AutoComplete {
  On = 'on',
  Off = 'off',
}

export enum ComponentSize {
  ExtraSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum ComponentStatus {
  Default = 'default',
  Loading = 'loading',
  Error = 'error',
  Valid = 'valid',
  Disabled = 'disabled',
}

export enum IconFont {
  AddCell = 'add-cell',
  Alerts = 'alerts',
  AlertTriangle = 'alert-triangle',
  Annotate = 'annotate',
  AnnotatePlus = 'annotate-plus',
  AuthZero = 'authzero',
  BarChart = 'bar-chart',
  Bell = 'bell',
  BellRinging = 'bell-ringing',
  BellSolid = 'bell-solid',
  BookCode = 'book-code',
  BookPencil = 'book-pencil',
  Book = 'book',
  Brush = 'brush',
  BucketOutline = 'bucket-outline',
  BucketSolid = 'bucket-solid',
  Calendar = 'calendar',
  Capacitor = 'capacitor2',
  CaretDown = 'caret-down',
  CaretLeft = 'caret-left',
  CaretRight = 'caret-right',
  CaretUp = 'caret-up',
  Chat = 'chat',
  Checkmark = 'checkmark',
  Circle = 'circle',
  CircleThick = 'circle-thick',
  Clock = 'clock',
  Cloud = 'cloud',
  CogOutline = 'cog-outline',
  CogThick = 'cog-thick',
  Collapse = 'collapse',
  CrownOutline = 'crown-outline',
  CrownSolid = 'crown2',
  Cube = 'cube',
  Cubo = 'cubo',
  CuboNav = 'cubo-nav',
  Cubouniform = 'cubo-uniform',
  CurrencyEUR = 'currency-eur',
  CurrencyGBP = 'currency-gbp',
  CurrencyUSD = 'currency-usd',
  Dashboards = 'dashboards',
  DashF = 'dash-f',
  DashH = 'dash-h',
  DashJ = 'dash-j',
  Disks = 'disks',
  DisksNav = 'disks-nav',
  Download = 'download',
  DragToExpand = 'drag-to-expand',
  Duplicate = 'duplicate',
  Erlenmeyer = 'erlenmeyer',
  ExpandA = 'expand-a',
  ExpandB = 'expand-b',
  Export = 'export',
  Eye = 'eye',
  Function = 'fn',
  FunnelOutline = 'funnel-outline',
  FunnelSolid = 'funnel-solid',
  EyeClosed = 'eye-closed',
  EyeOpen = 'eye-open',
  GitHub = 'github',
  Google = 'google',
  GraphLine = 'graphline-2',
  Group = 'group',
  HeartSolid = 'heart-solid',
  Heroku = 'heroku',
  HerokuSimple = 'heroku-simple',
  Import = 'import',
  Layers = 'layers',
  Link = 'link',
  Lock = 'lock',
  Maximize = 'maximize',
  Minimize = 'minimize',
  Moon = 'moon',
  Merge = 'merge',
  NavChat = 'nav-chat',
  OAuth = 'oauth',
  Octagon = 'octagon',
  Okta = 'okta',
  Pause = 'pause',
  Pencil = 'pencil',
  Play = 'play',
  Plus = 'plus',
  PlusSkinny = 'plus-skinny',
  Polaroid = 'polaroid',
  Pulse = 'pulse-c',
  Redo = 'redo',
  Refresh = 'refresh',
  Remove = 'remove',
  Search = 'search',
  Server = 'server2',
  Share = 'share',
  ShareSolid = 'share-solid',
  Shield = 'shield',
  ShieldSolid = 'shield-solid',
  Shuffle = 'shuffle',
  Square = 'square',
  SquareCheck = 'square-check',
  Star = 'star',
  Stop = 'stop',
  Sun = 'sun',
  TextBlock = 'text-block',
  Trash = 'trash',
  Triangle = 'triangle',
  Undo = 'undo',
  Upgrade = 'upgrade',
  User = 'user',
  UserAdd = 'user-add',
  UserOutline = 'user-outline',
  UserRemove = 'user-remove',
  UsersDuo = 'users-duo',
  UsersTrio = 'users-trio',
  Wand = 'wand',
  Wood = 'wood',
  Wrench = 'wrench',
  WrenchNav = 'wrench-nav',
  Zap = 'zap',
}

export enum Direction {
  Left = 'CaretLeft',
  Right = 'CaretRight',
}

export enum InputType {
  Text = 'text',
  Number = 'number',
  Password = 'password',
  Email = 'email',
  Checkbox = 'checkbox',
  Range = 'range',
}
